import { useEffect } from 'react';
import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';
import { inputValidator } from './inputErrors';

/*
 * This serve as a wrapper for useErrors hook to configure the result of useErrors hook.
 */
function useButtonWidgetErrors (props) {
    const {
        input,
    } = props;

    const store = useErrorStore();

    const {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    } = useErrors({
        hook: 'useButtonWidgetErrors',
        useTouched: true,
        input,
        inputValidator,
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.getButtons,
            store.observed.errors.uploadWidgetAssets,
            store.observed.errors.generateButtonImage,
            store.observed.errors.addWidget,
            store.observed.errors.editWidgets,
            store.observed.errors.deleteWidgets,
        ],
    });

    useEffect(() => {

    }, [errors]);

    /*
     * This response will be consumed by the UI components...
     */
    return {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    };
}

export default useButtonWidgetErrors;
